import React from 'react';
import {
    Box,
    Typography,
} from '@mui/material';

export default function SimpleComponent({ counter }) {
    return (
        <Box sx={{ p: 5, backgroundColor: 'lightblue' }}>
            <Typography variant="h2">Simple Component</Typography>
            <Typography variant="h3">Counter: {counter}</Typography>
        </Box>
    );
}
